import { useRandom4Query } from '@/hooks/RQHooks/tour/main/useRandom4Query';

import ExperienceProductGrid from '@/components/ExperienceProductGrid';
import SectionTitle from '../common/SectionTitle';
export default function WeekendSection() {
  const { data, isPending } = useRandom4Query();

  return (
    <div>
      <SectionTitle
        title={'숨겨진 재미, 농어촌 여행'}
        slogan={'놀러갈 고민 끝, 농어촌에서 보내는 하루'}
      />
      <ExperienceProductGrid data={data ?? []} />
    </div>
  );
}
